$.plugins.menu = {
	__init: function(config) {
		this.addClass('menu');
		
		if (game.panel) {
			game.panel.registerMenu(this);
		}
		
		if (config.transition) {
			this.addClass(config.transition);
		}
		
		this.addClass('show').hide();
	},
	
	addItem: function(item) {
		item.appendTo(this);
		
		return this;
	},
	
	clear: function() {
		return this.empty();
	},
	
	toggle: function() {
		if (this.hasClass('show')) {
			return this.hide();
		}
		
		else {
			return this.show();
		}
	},
	
	show: function() {
		if (this.hasClass('show')) {
			return this;
		}
		
		if(game.panel && game.panel.menu) {
			game.panel.menu.trigger('showMenu');
		}
		
		this.addClass('show');
		this.css('display', null);
		this.reinsert();
		
		return this;
	},
	
	hide: function() {
		if (!this.hasClass('show')) {
			return this;
		}
		
		if(game.panel && game.panel.menu) {
			game.panel.menu.trigger('hideMenu');
		}
		
		this.removeClass('show');
		this.reinsert();
		setTimeout((function() {
			if (!this.hasClass('show')) {
				this.css('display', 'none');
			}
		}).bind(this), 500);
		
		return this;
	},
};



/** WEBPACK FOOTER **
 ** /Users/kevinduarte/SG/roc2/engine/public-src/spingames/panel/js/menu.js
 **/